import { __assign } from "tslib";
import * as React from 'react';
function IconPinSizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M8 2C10.7536 2 13 4.37767 13 7.32845C13 9.04361 11.5134 11.2084 8.31488 13.7526L8 14C4.58408 11.3485 3 9.09894 3 7.32845C3 4.37767 5.24638 2 8 2ZM8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5Z" })));
}
export default IconPinSizeM;
